import {
  U21FormField,
  U21FormFieldTypes,
  U21Spacer,
} from 'app/shared/u21-ui/components';
import { required } from 'app/shared/utils/validation';

export const SaveFilterFormContent = () => {
  return (
    <U21Spacer spacing={2}>
      <U21FormField
        label="Title"
        name="title"
        required
        type={U21FormFieldTypes.TEXT}
        validate={required('Filter title is required.')}
        fieldProps={{
          autoFocus: true,
          inputProps: { maxLength: 255 },
          placeholder: 'Name your saved filter...',
        }}
      />
      <U21FormField
        label="Description"
        name="description"
        type={U21FormFieldTypes.TEXT}
        fieldProps={{
          inputProps: { maxLength: 120 },
          placeholder: 'Add a short description...',
        }}
      />
    </U21Spacer>
  );
};
